export class TargetData {
    date!: string;
    dateName!: string;
    target!: number;
    targetPremium!: number;
    sellCount!: number;
    sellValue!: number;
    targetReached!: boolean;
    targetPremiumReached!: boolean;
    sellArray!: string;

    get sellArrayArray(): number[] {
        const resultStr = this.sellArray.split(',');
        const resultNumbers = resultStr.map(x => parseInt(x, 10));
        const maxNumber = Math.max(...resultNumbers);
        const result = resultNumbers.map(x => (x / maxNumber) * 100);
        return result;
    }
    get completionPercentage() {
        if (!this.targetReached) {
            return ((this.sellCount / this.target) * 100);
        } else if (this.targetPremium > 0){
            return ((this.sellCount / this.targetPremium) * 100);
        } else {
            return 100;
        }
    }

    constructor(result: any) {
      this.date = result.date;
      this.dateName = result.dateName;
      this.target = result.target;
      this.targetPremium = result.targetPremium;
      this.sellCount = result.sellCount;
      this.sellValue = result.sellValue;
      this.targetReached = result.targetReached;
      this.targetPremiumReached = result.targetPremiumReached;
      this.sellArray = result.sellArray;
    }
}
